<template>
  <div class="box-upload-ads">
    <Navbar />
    <div class="upload-ads">
      <b-container class="text-left">
        <b-row>
          <b-col>
            <b-card no-body>
              <b-tabs card class="tab">
                <b-tab title="Banner Ads 1" active>
                  <b-card-text>
                    <b-form-file
                      v-model="BannerAds1"
                      :state="stateBannerAds1"
                      @input="changeBannerAds1"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewBannerAds1" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Banner Ads 2">
                  <b-card-text>
                    <b-form-file
                      v-model="BannerAds2"
                      :state="stateBannerAds2"
                      @input="changeBannerAds2"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewBannerAds2" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Left Box Ads 1">
                  <b-card-text>
                    <b-form-file
                      v-model="LeftBoxAds1"
                      :state="stateLeftBoxAds1"
                      @input="changeLeftBoxAds1"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewLeftBoxAds1" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Slide Ads 1">
                  <b-card-text>
                    <b-form-file
                      v-model="SlideAds1"
                      :state="stateSlideAds1"
                      @input="changeSlideAds1"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewSlideAds1" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Slide Ads 2">
                  <b-card-text>
                    <b-form-file
                      v-model="SlideAds2"
                      :state="stateSlideAds2"
                      @input="changeSlideAds2"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewSlideAds2" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Slide Ads 3">
                  <b-card-text>
                    <b-form-file
                      v-model="SlideAds3"
                      :state="stateSlideAds3"
                      @input="changeSlideAds3"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewSlideAds3" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
                <b-tab title="Slide Ads 4">
                  <b-card-text>
                    <b-form-file
                      size="lg"
                      v-model="SlideAds4"
                      :state="stateSlideAds4"
                      @input="changeSlideAds3"
                      placeholder="เลือกไฟล์รูปภาพหรือลางไฟล์มาวางในนี้"
                      drop-placeholder="ลางไฟล์มาวางในนี้"
                    ></b-form-file>
                    <div class="box-img mt-3 text-left">
                      <b-img class="img-ads" center :src="imgPreviewSlideAds4" alt="Ads"></b-img>
                    </div>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
export default {
  components: { Navbar, Footer },
  data() {
    return {
      SlideAds4: null,
      stateSlideAds4: null,
      imgPreviewSlideAds4:
        "https://www.kmppartners.info/ebidding/img/Slide4.jpg",
      SlideAds3: null,
      stateSlideAds3: null,
      imgPreviewSlideAds3:
        "https://www.kmppartners.info/ebidding/img/Slide3.jpg",
      SlideAds2: null,
      stateSlideAds2: null,
      imgPreviewSlideAds2:
        "https://www.kmppartners.info/ebidding/img/Slide2.png",
      SlideAds1: null,
      stateSlideAds1: null,
      imgPreviewSlideAds1:
        "https://www.kmppartners.info/ebidding/img/Slide1.png",
      LeftBoxAds1: null,
      stateLeftBoxAds1: null,
      imgPreviewLeftBoxAds1:
        "https://www.kmppartners.info/ebidding/img/LeftBoxAds1.jpg",
      BannerAds1: null,
      stateBannerAds1: null,
      imgPreviewBannerAds1:
        "https://www.kmppartners.info/ebidding/img/BannerAds1.jpg",
      BannerAds2: null,
      stateBannerAds2: null,
      imgPreviewBannerAds2:
        "https://www.kmppartners.info/ebidding/img/BannerAds2.jpg"
    };
  },
  methods: {
    changeLeftBoxAds1: function(e) {
      if (this.LeftBoxAds1 !== null) {
        this.stateLeftBoxAds1 = true;
        this.imgPreviewLeftBoxAds1 = URL.createObjectURL(e);
      } else {
        this.stateLeftBoxAds1 = false;
      }
    },
    changeBannerAds1: function(e) {
      this.b64BannerAds1 = null;
      if (this.BannerAds1 !== null) {
        this.stateBannerAds1 = true;
        this.imgPreviewBannerAds1 = URL.createObjectURL(e);
        this.fileToBase64(e, "BannerAds1");
      } else {
        this.stateBannerAds1 = false;
      }
    },
    changeBannerAds2: function(e) {
      if (this.BannerAds2 !== null) {
        this.stateBannerAds2 = true;
        this.imgPreviewBannerAds2 = URL.createObjectURL(e);
      } else {
        this.stateBannerAds1 = false;
      }
    },
    changeSlideAds1: function(e) {
      if (this.SlideAds1 !== null) {
        this.stateSlideAds1 = true;
        this.imgPreviewSlideAds1 = URL.createObjectURL(e);
      } else {
        this.stateSlideAds1 = false;
      }
    },
    changeSlideAds2: function(e) {
      if (this.SlideAds2 !== null) {
        this.stateSlideAds2 = true;
        this.imgPreviewSlideAds2 = URL.createObjectURL(e);
      } else {
        this.stateSlideAds2 = false;
      }
    },
    changeSlideAds3: function(e) {
      if (this.SlideAds3 !== null) {
        this.stateSlideAds3 = true;
        this.imgPreviewSlideAds3 = URL.createObjectURL(e);
      } else {
        this.stateSlideAds3 = false;
      }
    },
    changeSlideAds4: function(e) {
      if (this.SlideAds4 !== null) {
        this.stateSlideAds4 = true;
        this.imgPreviewSlideAds4 = URL.createObjectURL(e);
      } else {
        this.stateSlideAds4 = false;
      }
    },
    fileToBase64: function(file, value) {
      let reader = new FileReader();
      reader.onloadend = function() {
        var b64 = reader.result.replace(/^data:.+;base64,/, "");
        if (value === "BannerAds1") {
          if (file.type === "image/jpeg") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: value
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        } else if (value === "BannerAds2"){
          if (file.type === "image/jpeg") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: value
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        } else if (value === "SlideAds4"){
          if (file.type === "image/jpeg") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: "Slide4"
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        } else if (value === "SlideAds3"){
          if (file.type === "image/jpeg") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: "Slide3"
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        } else if (value === "SlideAds2"){
          if (file.type === "image/png") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: "Slide2"
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        } else if (value === "SlideAds1"){
          if (file.type === "image/png") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: "Slide1"
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        } else {
          if (file.type === "image/jpeg") {
            axios
              .post("https://www.kmppartners.info:1030/api/ebidding_image_ads", {
                base64: b64,
                name: "LeftBoxAds1"
              })
              .then(res => {
                alert(res.data.status);
              });
          } else {
            alert("ประเภทไฟล์ไม่ถูกต้อง");
          }
        }
      };
      reader.readAsDataURL(file);
    }
  }
};
</script>

<style>
.box-upload-ads {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.upload-ads {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 10%;
  color: black;
}
.tab a {
  color: black !important;
}
</style>